import { useContext, useEffect, useState } from 'react';
import { Box, Button, Stack, SvgIcon, useTheme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Plus } from '../../assets';
import { UserContext } from '../../components/shared/useUser';
import { useNavigate } from 'react-router-dom';
import PageArea from '../../components/shared/PageArea';
import PageTitle from '../../components/shared/PageTitle';
import OrderTypesTab from './components/OrderTypesTab';

const OrderTypesPage = () => {
  const { t } = useTranslation('orderTypes');
  const theme = useTheme();
  const navigate = useNavigate();

  const { hasPermissionTo } = useContext(UserContext);
  const [hasPermissionToCreateOrderType, setHasPermissionToCreateOrderType] = useState<boolean>(false);

  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.values.md}px)`);

  useEffect(() => {
    setHasPermissionToCreateOrderType(hasPermissionTo(['OrderTypeCreate', 'ConfigurationAdmin']));
  }, [hasPermissionTo]);

  const canViewOrderTypes = hasPermissionTo(['OrderTypeView', 'ConfigurationAdmin']);

  if (!canViewOrderTypes) {
    return null;
  }

  const handleCreateNew = () => {
    navigate('/order-types/create');
  };

  return (
    <PageArea>
      <Stack
        width='100%'
        spacing={2}
        direction={isMobile ? 'column' : 'row'}
        sx={{
          justifyContent: 'space-between',
          mb: 4, // Add margin bottom for spacing
        }}
      >
        <Box width={isMobile ? '100%' : 'auto'}>
          <PageTitle>{t('pageTitle')}</PageTitle>
        </Box>

        {hasPermissionToCreateOrderType && (
          <Box
            width={isMobile ? '100%' : 'auto'}
            sx={{
              display: 'flex',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
            }}
          >
            <Button
              variant="primary"
              size="lg"
              startIcon={<SvgIcon><Plus fill='white' /></SvgIcon>}
              onClick={handleCreateNew}
              sx={{
                mb: { xs: 4, md: 0 },
              }}
            >
              {t('createNew')}
            </Button>
          </Box>
        )}
      </Stack>
      
      <OrderTypesTab onCreateNew={handleCreateNew} />
    </PageArea>
  );
};

export default OrderTypesPage;
